import { render, staticRenderFns } from "./StudioTopBar.vue?vue&type=template&id=5f68156e&scoped=true&"
import script from "./StudioTopBar.vue?vue&type=script&lang=ts&"
export * from "./StudioTopBar.vue?vue&type=script&lang=ts&"
import style0 from "./StudioTopBar.vue?vue&type=style&index=0&id=5f68156e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f68156e",
  null
  
)

export default component.exports